import React from 'react';
import { CnSelect } from '@/components/cn-select';
import RegionFlag from './region-flag';
import currencyMap from './currency-map';
const CnCurrencySelect = (props) => {
    const { currencyDataSource = [], ...otherProps } = props;
    const clsPrefix = 'cn-ui-m-currency-select';
    const renderItem = (item) => {
        const itemValue = item.value;
        const currencyDetail = currencyMap[itemValue];
        if (currencyDetail) {
            return (React.createElement("div", { className: `${clsPrefix}-selection-item` },
                React.createElement(RegionFlag, { value: currencyDetail.country }),
                React.createElement("div", { className: `${clsPrefix}-selection-label` }, `${currencyDetail.value} ${currencyDetail.label}`)));
        }
        return (React.createElement("div", { className: `${clsPrefix}-selection-item` },
            React.createElement(RegionFlag, null),
            itemValue));
    };
    const renderSelection = (opts) => {
        if (!opts.length)
            return null;
        return (React.createElement("div", { className: `${clsPrefix}-selection` }, opts.map((item) => renderItem(item))));
    };
    const renderPreview = (values) => {
        if (!values.length)
            return null;
        return (React.createElement("div", { className: `${clsPrefix}-selection` }, values.map((item) => renderItem(item))));
    };
    return (React.createElement(CnSelect, { renderItem: renderItem, renderSelection: renderSelection, renderPreview: renderPreview, dataSource: currencyDataSource, ...otherProps }));
};
export { CnCurrencySelect };
